module.exports = __webpack_public_path__ + "static/img/RS4261_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS4261_1.png
// module id = QUEO
// module chunks = 0